// frontend/src/services/offlineStorage.js
export const storeOfflineData = (key, data) => {
  try {
    localStorage.setItem(`poslah_offline_${key}`, JSON.stringify({
      data,
      timestamp: Date.now()
    }));
    return true;
  } catch (error) {
    console.error('Failed to store offline data:', error);
    return false;
  }
};

export const getOfflineData = (key) => {
  try {
    const storedData = localStorage.getItem(`poslah_offline_${key}`);
    if (!storedData) return null;
    
    return JSON.parse(storedData).data;
  } catch (error) {
    console.error('Failed to retrieve offline data:', error);
    return null;
  }
};

export const getOfflinePendingRequests = () => {
  const pendingRequests = [];
  
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('poslah_offline_pending_')) {
        const request = JSON.parse(localStorage.getItem(key));
        pendingRequests.push(request);
      }
    }
  } catch (error) {
    console.error('Error retrieving pending requests:', error);
  }
  
  return pendingRequests;
};

export const queueOfflineRequest = (endpoint, method, data) => {
  const id = `poslah_offline_pending_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
  localStorage.setItem(id, JSON.stringify({
    id,
    endpoint,
    method,
    data,
    timestamp: Date.now()
  }));
};

export const removeOfflineRequest = (id) => {
  localStorage.removeItem(id);
};